export interface HeatmapCellClickPayload {
    date: string;
    hour?: number;
    value: number;
}

export interface HeatmapCellLike {
    y: number;
    meta: {
        date: string;
        hour?: number;
    };
}

/** Resolve an Apex heatmap dataPointSelection into cell meta; ignores empty cells. */
export const resolveHeatmapCellClick = (
    series: Array<{ data: HeatmapCellLike[] }>,
    seriesIndex: number | undefined,
    dataPointIndex: number | undefined
): HeatmapCellClickPayload | null => {
    if (seriesIndex == null || seriesIndex < 0 || dataPointIndex == null || dataPointIndex < 0) {
        return null;
    }

    const point = series[seriesIndex]?.data?.[dataPointIndex];
    if (!point?.meta?.date || !(point.y > 0)) {
        return null;
    }

    return {
        date: point.meta.date,
        ...(typeof point.meta.hour === 'number' ? { hour: point.meta.hour } : {}),
        value: point.y
    };
};
